import React from 'react';
import { Skeleton } from '@beeline.com/bp-design-system';
import { DrawerColumnSplit, DrawerItemView } from './DrawerItemView';

interface Props {
  label?: string;
  loading?: boolean;
  dataTest: string;
  columnSplit?: DrawerColumnSplit;
  rightAlign?: boolean;
}

export const DrawerSummaryItem: React.FC<React.PropsWithChildren<Props>> = ({
  children,
  label,
  loading,
  dataTest,
  columnSplit,
  rightAlign = false
}) => (
  <DrawerItemView rightAlign={rightAlign} label={label ?? ''} dataTest={dataTest} columnSplit={columnSplit}>
    {loading ? <Skeleton randomWidthAsNumber={[40, 80]} inline /> : (children ?? '-')}
  </DrawerItemView>
);
